import { render, staticRenderFns } from "./menu-management.vue?vue&type=template&id=4c9564ce&scoped=true"
import script from "./menu-management.vue?vue&type=script&lang=js"
export * from "./menu-management.vue?vue&type=script&lang=js"
import style0 from "./menu-management.vue?vue&type=style&index=0&id=4c9564ce&prod&scoped=true&lang=scss"
import style1 from "./menu-management.vue?vue&type=style&index=1&id=4c9564ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9564ce",
  null
  
)

export default component.exports